@if (!hideTitle && data.title) {
  <h2 tabindex="-1">{{ data.title }}</h2>
}

<div class="elements">
  <ng-template
    [groupItem]="data"
    [groupControl]="control"
    uiFormDynamicElements
  ></ng-template>
</div>

@if (data.submit) {
  <ui-form-submit [data]="data.submit" (submitted)="onSubmit($event)"></ui-form-submit>
}
